<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-certificates">
        <form class="mc-certificates__form mc-form" id="certificateForm" @submit.prevent="submitForm" method="post" autocomplete="off">
          <div class="mc-certificates__checkout">
            <div v-if="serverError" class="mc-form__message mc-form__message--alert" v-html="serverError">

            </div>
            <div v-if="success" class="mc-form__message mc-form__message--success" v-html="success">

            </div>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field" :class="{ isError: errors.name }">
                <label class="mc-form__label" for="reason">
                  Причина удаления
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.name" class="mc-form__error-text">
                  {{ errors.name }}
                </span>
                <input class="mc-form__input" id="reason" type="text" v-model="formData.name" placeholder="Причина удаления" required>
              </div>
            </fieldset>
          </div>
          <button class="mc-form__button-submit mc-button mc-button--color js-button-submit" type="submit" :disabled="isSubmitting">
                            <span class="mc-button__text">

              {{ isSubmitting ? 'Отправка запроса...' : 'Удалить аккаунт' }}
                            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';

export default {
  data: () => ({
    formData: {
      name: '',
    },
    errors: {},
    serverError: null,
    formSubmitted: false,
    isSubmitting: false,
    success: ''
  }),
  mounted() {

  },
  async created() {
  },
  computed: {

  },
  components: {MaskInput},
  methods: {

    scrollToFirstError() {
      this.$nextTick(() => {
        // Find first error element or server error message
        const firstErrorElement = this.serverError
            ? document.querySelector('.mc-form__message')
            : document.querySelector('.isError');

        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },

    validateForm() {
      this.errors = {};



      // Validate name
      if (!this.formData.name.trim()) {
        this.errors.name = 'Причина удаления обязательна';
      } else if (this.formData.name.length < 10) {
        this.errors.name = 'Причина удаления должно содержать минимум 10 символов';
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },

    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.serverError = null;

      try {
        // Prepare data for submission
        const formDataToSubmit = {
          ...this.formData,
        };

        const response = await axios.post('/api/user/remove/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'cert')
              this.errors[response.data.errors[i].code] = response.data.errors[i].message;
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }

        this.formSubmitted = true;
        this.success = 'Запрос отправлен';
        this.formData = {};
        // Scroll to the success message
        this.scrollToFirstError();

      } catch (error) {
        /*let errorMessage = 'Произошла техническая ошибка. Попробуйте еще раз.';

        if (error.response && error.response.data) {
          // Handle axios error responses
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
          // Use the thrown error message
          errorMessage = error.message;
        }

        this.serverError = errorMessage;*/
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    }
  },
}
</script>

